const ENDPOINT_BASE='/addresses/';

export const getAddressUrl = (id) => {
    return ENDPOINT_BASE+id;
}

export const getAddressesUrl = () => {
    return ENDPOINT_BASE+'all';
}

export const getCreateAddressUrl = () => {
    return ENDPOINT_BASE;
}

export const getDeleteAddressUrl = (id) => {
    return ENDPOINT_BASE+id;
}